import React, { Component } from "react";
import { Modal } from "reactstrap";

class RegisterModal extends Component {
  render() {
    const { show, title, subTitle, detail, showCancel } = this.props;
    return (
      <Modal isOpen={show} aria-labelledby="contained-modal-title-vcenter" centered>
        <div className="modal-body">
          <center>
            <h3>{title}</h3>
            <h5>{subTitle}</h5>
            <p>{detail}</p>
          </center>
        </div>
        <div className="modal-footer flex-center">
          {showCancel && <button type="button" className="btn btn-cc btn-sm" onClick={this.props.onCancel}>ยกเลิก</button>}
          <button type="button" className="btn btn-cf btn-sm" onClick={this.props.onOK}>ตกลง</button>
        </div>
      </Modal >
    );
  }
}

export default RegisterModal;